import { Loyalty } from '@getjust/api-schema';
import { atom } from 'jotai';

export type LoyaltyCampaign = Loyalty.LoyaltyCampaign;
export type LoyaltyRedemptionOption = Loyalty.LoyaltyRedemptionOption;
export type LoyaltyBalance = Extract<Loyalty.LoyaltyGetBalanceResponseBody, { outcome: 'found' }>;

export const loyaltyBalanceAtom = atom<LoyaltyBalance | undefined>(undefined);
export const loyaltyRedeemedAtom = atom<boolean>(false);
export const loyaltyDiscountCodeAtom = atom<string | undefined>(undefined);
